export default ({ items }) =>
  items.map(({ text, icon, onclick }, index) => (
    <div className="column info-card is-flex" key={text.split(' ')[0] + index} onClick={onclick}>
      <div className="column is-full">
        <div>
          <div className="image">{icon}</div>
          <p className="info-text">{text}</p>
        </div>
      </div>
      <style jsx="true">{`
        .info-card {
          padding-left: 10px;
          padding-right: 10px;
          padding-top: 0px;
          padding-bottom: 10px;
          max-width: 180px;
        }
        .info-text {
          min-height: 60px;
          font-size: 16px;
          width: 144px;
          height: 51px;
          margin-top: 6px;
          margin-bottom: 0px;
          margin-left: auto;
          margin-right: auto;
        }
      `}</style>
    </div>
  ));
